import { useQuery } from '@tanstack/react-query'
import { IApiBaseTypes } from '@/types/query-api'
import { IResponseType } from '@/types/response-type'
import { IGetDocumentsResponse } from './type'
import { APIInstance } from '@/utils/functions/instance'

export function useGetDocuments({
  disableToast,
  ...rest
}: IApiBaseTypes<{}> = {}) {
  return useQuery({
    queryFn: async () =>
      await APIInstance<IGetDocumentsResponse>({
        url: 'mrf/documents/',
        method: 'get'
      }),
    queryKey: ['documentList'],
    retry: 0,
    refetchInterval: false,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: false,
    select: (data) => data.data,
    ...rest
  })
}
